import { useEffect, useRef } from "react";
import { Pagination as ZhPagination, type PaginationProps } from "zhihao-ui-react";

/** 统一恢复旧 Vue ProTable 的完整分页布局，避免迁移页遗漏关键分页能力。 */
export function AdminPagination({
    current = 1,
    pageSizeOptions = [10, 20, 30, 40, 50, 100],
    showLessItems = false,
    showTotal = total => `共${total}条数据`,
    locale,
    ...props
}: PaginationProps) {
    const paginationHostRef = useRef<HTMLDivElement>(null);
    const hasTotal = Boolean(props.total);

    useEffect(() => {
        if (!hasTotal) return undefined;

        // Ant 分页快速跳转输入框默认为空，Vue 旧版会展示当前页（初始为 1）。
        // 在公共适配层补齐默认值，避免每个列表页重复处理且不干扰用户正在输入的内容。
        // zhihao Pagination 会在自身副作用中刷新快速跳转节点，放到当前渲染任务之后可确保
        // 默认值写入发生在该刷新之后，同时不干扰用户正在输入的内容。
        const timer = window.setTimeout(() => {
            const input = paginationHostRef.current?.querySelector<HTMLInputElement>(
                ".ant-pagination-options-quick-jumper input"
            );
            if (input && (!input.value || document.activeElement !== input)) {
                input.value = String(current);
            }
        }, 0);
        return () => window.clearTimeout(timer);
    }, [current, hasTotal]);

    // Vue ProTable 的分页组件以 total 作为显示条件；空列表只展示表格空态。
    if (!hasTotal) return null;

    return (
        <div ref={paginationHostRef} className="admin-pagination-host">
            <ZhPagination
                {...props}
                current={current}
                // 旧 Vue 分页下拉项统一显示为“数量 / page”，覆盖 zhihao 分页默认中文文案。
                locale={{ items_per_page: "/ page", ...locale }}
                pageSizeOptions={pageSizeOptions}
                showLessItems={showLessItems}
                // 列表统一沿用旧 Vue ProTable 的完整布局；调用方历史遗留的 false 不得隐藏关键控件。
                showQuickJumper={true}
                showSizeChanger={true}
                showTotal={showTotal}
                hideOnSinglePage={false}
            />
        </div>
    );
}

export default AdminPagination;
